import userFiltersSignal, {
	setUserFilters,
} from '@UI/Pages/Administration/Users/Filters/Signals/userFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

type FacilityOption = { readonly id: number; readonly name: string };

type Props = {
	readonly facilities: readonly FacilityOption[];
	readonly loading: boolean;
	readonly withLabel?: boolean;
};

const FacilityFilter: React.FC<Props> = ({ facilities, loading, withLabel = false }) => {
	const currentFilters = useSignalValue(userFiltersSignal);

	const handleFacilityChange = React.useCallback((facilityId: number | null) => {
		setUserFilters(userFiltersSignal.peek().setFacilityId(facilityId));
	}, []);

	return (
		<Dropdown<number>
			name="userFacility"
			label="Agence"
			isLabelHidden={!withLabel}
			placeholder="Toutes les agences"
			options={facilities}
			optionLabel="name"
			optionValue="id"
			loading={loading}
			showClear
			value={currentFilters.facilityId}
			onChange={handleFacilityChange}
		/>
	);
};

export default FacilityFilter;
